<template>
	<div class="page">
		<!-- 头部 -->
    <Header :index="1" @login="login"></Header>
		<!-- 面包屑导航 -->
		<div class="sec_top_position">
			<div class="curPosition">
				<img src="@/assets/img/fruit-transfer/icon14.png">
				您所在的位置：<a :href="homeHref">首页</a> &gt;
				<a href="#/platform/fruit-transfer/list">成果转化</a> &gt;
			    <a href="#">成果转化详情</a>
			</div>
		</div>
		<div class="query-result">
			<div class="query-list">
				<el-carousel height="2.3rem" style="width: 3.6rem;">
				      <el-carousel-item v-for="(item,index) in imgList" :key="index">
				        <img :src="item.src" style="width: 3.6rem;height:2.3rem;">
				      </el-carousel-item>
				</el-carousel>
				<div class="list-content">
					<div class="query-list-title cursor">{{detailData.fruitName}}</div>
					<el-row :gutter="30">
					  <!-- <el-col :span="8"><div class="colfont">成果形式：专利</div></el-col> -->
					  <el-col :span="12"><div class="colfont">成果阶段：{{detailData.fruitStageName}}</div></el-col>
					  <el-col :span="12"><div class="colfont">转化方式：{{detailData.wayNames}}</div></el-col>
					</el-row>
					<div class="time">发布时间：{{detailData.publishTime | dateFormat("YYYY-MM-DD hh:mm")}}</div>
					<div class="listbott">
						<div class="funds">意向价格：<span>{{detailData.intentionPriceName}}</span></div>
						<div class="zixun-btn">
							<el-button type="warning" @click="showContact">我要咨询</el-button>
							<span class="explain">点击对接咨询获取联系方式</span>
						</div>
					</div>
				</div>
				<!-- 咨询弹出框 -->
				<el-dialog title="联系方式" :visible.sync="dialogVisible" width="16%" top="25vh">
				  <div class="dialog-text">联系人：{{detailData.contactPerson}}</div>
				  <div class="dialog-text">联系电话：{{detailData.contactPhone}}</div>
				</el-dialog>
			</div>
			<div class="fruit-detail">
				<div class="fruit-detail-title">成果详情</div>
				<div class="fruit-detail-con" v-if="!loginFlag">登录后可查看</div>
				<div class="fruit-detail-con" v-if="loginFlag">{{detailData.fruitIntroduction}}</div>
			</div>
			<div class="fruit-detail">
				<div class="fruit-detail-title">经济效益</div>
				<div class="fruit-detail-con" v-if="!loginFlag">登录后可查看</div>
				<div class="fruit-detail-con" v-if="loginFlag">{{detailData.economyBenefit}}</div>
			</div>
			
			<div class="about-fruit">
				<div class="about-fruit-title">相关成果</div>
				<!-- <div class="about-fruit-more"><span class="cursor">换一批</span>&ensp;&ensp;&ensp;&ensp;<span class="cursor">更多</span></div> -->
				<el-carousel :interval="4000" type="card" height="400px">
				    <el-carousel-item v-for="(item, index) in aboutFruit" :key="index" @click.native="goDetail(item.id)">
				      <el-card :body-style="{ padding: '0px' }">
				        <img :src="item.src" class="image">
				        <div class="rowcol-text">{{item.fruitName}}</div>
				      </el-card>
				    </el-carousel-item>
				  </el-carousel>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import queryConditionService from "@/api/platform-declare/fruit-transfer"
	import fileService from "@/api/file/fileApi"
	import setRemPc from '@/api/setrem'
	import Header from '@/views/platform/components/header.vue'
	import Footer from '@/views/platform/components/footer.vue'
	export default {
		components:{
			Header,
			Footer
		},
		data(){
			return{
				homeHref: process.env.VUE_APP_NAV_BASE_URL + 'ch00108/',
				loginFlag:false,
				id:'',
				detailData:{},
				dialogVisible: false,
				aboutFruit:[],
				imgList:[]
			}
		},
		created(){
			// this.login()
		    // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
			setRemPc();
		    window.addEventListener('resize', setRemPc);//浏览器窗口大小改变时调用rem换算方法
			this.getListDetail()
		},
		methods: {
			//接收header传过来的是否登录信息
			login(param){
				this.loginFlag = param
			},
			getListDetail(){
				this.id =  this.$route.query && this.$route.query.id;
				let params = {
				  id: this.id
				}
				queryConditionService
				    .fruitTransferDetail(params)
				    .then(res => {
						//console.log('详情',res);
				      this.detailData = res.data
					  if(res.data.related && res.data.related.length>0 ){
						  for(let i=0; i<res.data.related.length; i++){
							  if(res.data.related[i].files && res.data.related[i].files.length>0){
								  this.aboutFruit.push({id:res.data.related[i].id,fruitName:res.data.related[i].fruitName, src:fileService.getUrl(res.data.related[i].files[0].fileId)})
							  } else {
								  this.aboutFruit.push({id:res.data.related[i].id,fruitName:res.data.related[i].fruitName,src:require('@/assets/img/fruit-transfer/listimg.jpg')})
							  }
						  }
						
					  }
					  this.imgList=[];
					  if(this.detailData.files && this.detailData.files.length>0){
					  		for(let j=0; j<this.detailData.files.length; j++){
								 this.imgList.push({src:fileService.getUrl(this.detailData.files[j].fileId)})
					  			
					  		}
					  } else {
						  this.imgList.push({src:require('@/assets/img/fruit-transfer/listimg.jpg')})
					  }
				    })
				    .catch(error => {
				      console.log('error错误码',error);
				    })
				    .finally(() => {
				      this.loading = false;
				    });
			},
			//显示联系方式
			showContact(){
				if(this.loginFlag){
					this.dialogVisible = true
				} else {
					this.$message({
					    showClose: true,
					    message: '咨询前，请先登录！',
					    type: 'warning'
					});
				}
			},
			goDetail(id){
				this.$router.push({
				  path: '/platform/fruit-transfer/detail',
				  query: {
				    id: id
				  }
				})
				this.$router.go(0);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import url('~@/assets/css/breadnav.css');
	.page{
		font-size: 0.18rem;
		padding: 0;
		margin: -8px;
		background-color: #F5F5F5;
	}
	.w{
		width: 15.7rem;
		margin: 0 auto;
	}
	.q-display{
		display: flex;
		flex-direction: row;
	}
	.q-align{
		justify-content: center;
	}
	.conset{
		background-color: #ffffff;
		box-sizing: border-box;
	}
	.query-result{
	  @extend .w;
	  @extend .conset;
	  padding: 0.2rem 0.1rem 0.2rem 0.3rem;
	  margin-top: 0.25rem;
	}

	.query-list{
		@extend .q-display;
		margin: 0.1rem 0;
	}
	.list-content{
		flex: 1;
		border: 0.01rem solid #F9F9F9;
		box-sizing: border-box;
		padding: 0.2rem 0.1rem 0.1rem 0.3rem;
	}
	.cursor{
		cursor: pointer;
	}
	.cursor:hover{
		color:#00ABFF;
	}
	.query-list-title{
		font-size: 0.22rem;
		font-weight: 500;
		color: #479CF5;
		line-height: 0.4rem;
		margin-bottom: 0.2rem;
	}
	.query-list-tag{
		@extend .q-display;
	}
	.colfont{
		font-size: 0.18rem;
	}
	.dialog-text{
		font-size: 0.2rem;
		line-height: 0.4rem;
	}
	.time{
		margin: 0.22rem 0;
	}
	.listbott{
		@extend .q-display
	}
	.funds span{
		font-size: 0.23rem;
		color: #ff0000;
	}
	::v-deep .zixun-btn{
		margin-left: 3.5rem;
		.el-button {
		    padding: 0.14rem 0.2rem !important;
		    border-radius: 0.03rem !important;
			font-size: 0.2rem !important;
		}
		.explain{
			font-size: 0.16rem;
			color: #858585;
			margin-left: 0.1rem;
		}
	}
	.fruit-detail{
		&-title{
			height:0.2rem;
			box-sizing: border-box;
			padding-left: 0.2rem;
			border-left: 0.05rem solid #409EFF;
			font-size: 0.2rem;
			font-weight: bold;
			line-height: 0.2rem;
			margin: 0.2rem 0;
		}
		&-con{
			color:#878787;
			line-height: 0.35rem;
			
		}
	}
	.about-fruit{
		box-sizing: border-box;
		padding: 0.2rem 0;
		&-title{
			text-align: center;
			font-size: 0.32rem;
			margin: 0.3rem 0;
		}
		&-more{
			color:#636363;
			text-align: right;
			box-sizing: border-box;
			padding-right: 0.1rem;
		}
	}
	.rowcol-text{
		height:1.2rem;
		text-align: center;
		font-size: 0.2rem;
		color: #848484;
		box-sizing: border-box;
		padding: 0.25rem 0.3rem;
		line-height: 0.35rem;
	}
	.image {
	    width: 100%;
		height: 2.6rem;
	    display: block;
	  }
	  .con-mar{
		margin: 0.2rem 0.1rem 0 -0.1rem;
	  }
	  .dialog-text{
	  	font-size: 0.2rem;
	  	line-height: 0.4rem;
	  }
	  ::v-deep.el-checkbox-group{
	  	margin-left: 0.35rem;
	  }
	  ::v-deep .el-checkbox__label{
	  	font-size: 0.18rem;
	  	line-height: 0.3rem;
	  }
	  ::v-deep .el-dialog__title{
	  	color:#ffffff;
	  }
	  ::v-deep .el-dialog__headerbtn .el-dialog__close{
	  	color:#ffffff;
	  }
</style>
<style>
	.el-message__icon {
		font-size: 0.26rem !important;
	}
</style>